import { EVENTS } from '~/constants/events';
import { UserTransactionReferenceType } from '~/graphql/generated/graphql';

interface CoinTransactionResult {
  coins: number;
  referenceType: UserTransactionReferenceType;
  balanceAfter: number;
}

export const trackCoinsEarned = (
  analytics: { track: (event: string, props: Record<string, unknown>) => void },
  coinTransaction: CoinTransactionResult | null | undefined,
  sourceEntityId: string | null,
  sourceEntityName: string | null,
) => {
  if (!coinTransaction || coinTransaction.coins <= 0) {
    return;
  }

  const source = coinTransaction.referenceType === UserTransactionReferenceType.Referral
    || coinTransaction.referenceType === UserTransactionReferenceType.ReferralRedemption
    ? 'referral'
    : 'content_completion';

  analytics.track(EVENTS.UNIFIED_REWARDS_COINS_EARNED, {
    amount: coinTransaction.coins,
    source,
    sourceEntityId,
    sourceEntityName,
    newBalance: coinTransaction.balanceAfter,
  });
};
